import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../core/environments/environment';
import { lastValueFrom } from 'rxjs';
import { PlanoModel } from '../models/plano.model';
import { FuncionalidadeModel } from '../../gestaoSistema/models/funcionalidade.model';
import { PlanoFuncionalidadeModel } from '../models/plano.funcionalidade.model';


@Injectable({
  providedIn: 'root',
})
export class PlanoService {
  constructor(private http: HttpClient, private Router: Router) {}
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    withCredentials: true,

  };

  async buscarPlanos(filtros: any): Promise<PlanoModel[]> {
    try {
      return await lastValueFrom(
        this.http.post<PlanoModel[]>(
          `${environment.apiPlano}/findAll`,
          JSON.stringify(filtros),
          this.httpOptions
        )
      );
    } catch (error) {
      return [];
    }
  }
  async buscarFuncionalidadesPlano(filtros: any): Promise<FuncionalidadeModel[]> {
    try {
      return await lastValueFrom(
        this.http.post<FuncionalidadeModel[]>(
          `${environment.apiPlano}/findAllFuncionalidade`,
          JSON.stringify(filtros),
          this.httpOptions
        )
      );
    } catch (error) {
      return [];
    }
  }
  async buscarFuncionalidades(filtros: any): Promise<FuncionalidadeModel[]> {
    try {
      return await lastValueFrom(
        this.http.post<FuncionalidadeModel[]>(
          `${environment.apiFuncionalidade}/findAll`,
          JSON.stringify(filtros),
          this.httpOptions
        )
      );
    } catch (error) {
      return [];
    }
  }

  async buscarPlanoPorId(id: number): Promise<PlanoModel> {
    try {
      return await lastValueFrom(
        this.http.get<PlanoModel>(`${environment.apiPlano}/findById?id=${id}`, this.httpOptions)
      );
    } catch (error) {
      throw error;
    }
  }
  async salvarPlano(plano: PlanoModel): Promise<number> {
    try {
      return await lastValueFrom(
        this.http.post<PlanoModel>(
          `${environment.apiPlano}/create`,
          JSON.stringify(plano),
          this.httpOptions
        )
      ).then((res) => {
        return res.id;
      });

    } catch (error) {
      throw error;
    }
  }
  async vincularFuncionalidade(planoFuncionalidade: PlanoFuncionalidadeModel): Promise<boolean> {
    try {
      return await lastValueFrom(
        this.http.post<boolean>(
          `${environment.apiPlano}/vincularFuncionalidade`,
          JSON.stringify(planoFuncionalidade),
          this.httpOptions
        )
      ).then((res) => {
        return res;
      });

    } catch (error) {
      throw error;
    }
  }

  async desvincularFuncionalidade(planoFuncionalidade: PlanoFuncionalidadeModel): Promise<boolean> {
    try {
      return await lastValueFrom(
        this.http.post<boolean>(
          `${environment.apiPlano}/desvincularFuncionalidade`,
          JSON.stringify(planoFuncionalidade),
          this.httpOptions
        )
      ).then((res) => {
        return res;
      });

    } catch (error) {
      throw error;
    }
  }

}
